import { useQuery } from "react-query"
import { getDoc } from "~/actions/docs"

export const useGetDoc = (id) => {
  return useQuery(["doc", id], () => getDoc(id), {
    enabled: !!id,
  })
}
